module.exports = __webpack_public_path__ + "img/7.468abdb3.jpg";